import { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import { LoginPageLogo } from "../libs/SVGIcons";
import "../libs/styles/signin.css";

import {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
  set2FaAsRequired,
  setPasswordChangeAsRequired,
} from "../actions";

import { ErrorBoundary } from "react-error-boundary";
import axios from "../axios";
import AppConfig from "../constants/AppConfig";
import { LoginPageModes } from "../constants";
import { LoginLeftSidebar } from "./components/LoginLeftSidebar";
import { LoginLoading } from "./components/LoginLoading";
import { PasswordChange } from "./components/PasswordChangeForm";
import { TwoFactorAuthForm } from "./components";

class LoginPage extends Component {
  state = {
    email: null,
    password: null,
    mode: LoginPageModes.Login,
    userId: null,
    verificationCode: null,
    passwordFieldLabel: window.sys_app_translate("Password", "en"),
    passwordFieldPlaceHolder: window.sys_app_translate(
      "Enter your password",
      "en",
    ),
    confirmPassword: null,
    passwordResetAttempts: 0,
  };
  constructor() {
    super();
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  async loginUser(code = null, newPassword = null) {
    const { setLoading, signinUserIn, history } = this.props,
      { email, password } = this.state;
    setLoading(true);
    signinUserIn(
      {
        email: email,
        password: password,
        code: code,
        newpassword: newPassword,
      },
      history,
    );
  }
  async sendPasswordResetRequest() {
    const { handleAppError, showMessage, setLoading } = this.props,
      { passwordResetAttempts } = this.state;
    if (passwordResetAttempts === 3) {
      showMessage({
        type: "danger",
        title: window.sys_app_translate("Maximum Attempts Reached!", "en"),
        message: window.sys_app_translate(
          "Maximum attempts of 3 reached! Please try again later",
          "en",
        ),
      });
      return;
    }
    console.log("sending password reset request ...");
    try {
      setLoading(true);
      const response = await axios.post("/auth/send-verification-code", {
        userstring: this.state.email,
      }),
        data = response.data.data;
      if (data.smessage) {
        await this.setState({
          password: null,
          confirmPassword: null,
          userId: data.smessage,
          mode: LoginPageModes.CheckVerificationCode,
          passwordFieldLabel: window.sys_app_translate(
            "Verification Code",
            "en",
          ),
          passwordFieldPlaceHolder: window.sys_app_translate(
            "Enter received verification code",
            "en",
          ),
          passwordResetAttempts: passwordResetAttempts + 1,
        });
      }
      if (data.emessage) {
        showMessage({
          type: "success",
          title: window.sys_app_translate("Successful Operation!", "en"),
          message: data.emessage,
        });
      }
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async checkPasswordResetCode() {
    const { handleAppError, showMessage, setLoading } = this.props,
      { userId, verificationCode } = this.state;
    try {
      setLoading(true);
      const response = await axios.post("auth/check-verification-code", {
        userid: userId,
        verificationcode: verificationCode,
      }),
        data = response.data.data;
      if (data.result) {
        this.setState({
          password: null,
          confirmPassword: null,
          mode: LoginPageModes.changePassword,
          passwordFieldLabel: window.sys_app_translate("New Password", "en"),
          passwordFieldPlaceHolder: window.sys_app_translate(
            "Enter new password!",
            "en",
          ),
        });
      } else {
        showMessage({
          type: "danger",
          title: window.sys_app_translate("Wrong Verification Code!", "en"),
          message: window.sys_app_translate(
            "Verification Code is wrong!",
            "en",
          ),
        });
      }
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async changePassword() {
    const { handleAppError, showMessage, setLoading } = this.props,
      { userId, verificationCode, password, confirmPassword } = this.state;

    if (password !== confirmPassword) {
      showMessage({
        type: "danger",
        title: window.sys_app_translate("Passwords Do Not Match!", "en"),
        message: window.sys_app_translate(
          "Password and confirm password do not match!",
          "en",
        ),
      });
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post("auth/change-password", {
        userid: userId,
        verificationcode: verificationCode,
        password: password,
      }),
        data = response.data.data;
      if (data.result) {
        showMessage({
          type: "success",
          title: window.sys_app_translate("Successful Operation!", "en"),
          message: window.sys_app_translate(
            "Password changed successfully!",
            "en",
          ),
        });
        await this.setState({
          verificationCode: null,
          password: null,
          confirmPassword: null,
          email: null,
          mode: LoginPageModes.Login,
          passwordFieldLabel: window.sys_app_translate("Password", "en"),
          passwordFieldPlaceHolder: window.sys_app_translate(
            "Enter your password",
            "en",
          ),
        });
      } else {
        showMessage({
          type: "danger",
          title: window.sys_app_translate("Changing Failed!", "en"),
          message: window.sys_app_translate(data.error, "en"),
        });
      }
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.loginUser();
    }
  }
  componentDidMount() {
    this.props.setLoading(false);
    document.addEventListener("keydown", this.handleKeyDown);
    this.checkIfToShowSubdomainMessage();
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  checkIfToShowSubdomainMessage() {
    const { showMessage } = this.props;
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.os) {
      showMessage({
        type: "warning",
        title: "Login via subdomain",
        message: "You have to login only through: " + params.os,
      });
    }
  }
  errorFallback({ error, resetErrorBoundary }) {
    return (
      <div role="alert">
        <p>{window.sys_app_translate("Something went wrong", "en")}:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    );
  }
  _getFormTitle() {
    const { mode } = this.state;
    switch (mode) {
      case LoginPageModes.Login:
        return window.sys_app_translate("Login to your account!", "en");
      case LoginPageModes.SendVerificationCode:
        return window.sys_app_translate("Forgot Password", "en");
    }
  }
  submit(e) {
    console.log("submitting ...");
    e.preventDefault();
    const { mode } = this.state;
    if (mode === LoginPageModes.SendVerificationCode) {
      return this.sendPasswordResetRequest();
    }
    if (mode === LoginPageModes.CheckVerificationCode) {
      return this.checkPasswordResetCode();
    }
    if (mode === LoginPageModes.changePassword) {
      return this.changePassword();
    }
    if (mode === LoginPageModes.Login) {
      return this.loginUser();
    }
  }
  _getEmailAddress() {
    const { mode } = this.state;
    return (
      [LoginPageModes.Login, LoginPageModes.SendVerificationCode].includes(
        mode,
      ) && (
        <>
          <label style={{ marginTop: "44.8px", color: "#707070" }}>
            {window.sys_app_translate("Email Address or Username", "en")}
          </label>
          <input
            type="text"
            className="form-control inter inter-semi-bold"
            placeholder="Youraddress@email.com"
            onChange={(e) => {
              this.setState({
                email: e.target.value,
              });
            }}
          />
        </>
      )
    );
  }
  _getPasswordField() {
    const { mode, passwordFieldLabel, passwordFieldPlaceHolder } = this.state;
    return (
      [
        LoginPageModes.CheckVerificationCode,
        LoginPageModes.Login,
        LoginPageModes.changePassword,
      ].includes(mode) && (
        <>
          <label style={{ marginTop: "25.3px", color: "#707070" }}>
            {passwordFieldLabel}
          </label>
          <input
            type={
              mode !== LoginPageModes.CheckVerificationCode
                ? "password"
                : "text"
            }
            className="form-control inter inter-semi-bold"
            placeholder={passwordFieldPlaceHolder}
            key={mode}
            value={
              mode === LoginPageModes.CheckVerificationCode
                ? this.state.verificationCode
                : this.state.password
            }
            onChange={(e) => {
              if (mode === LoginPageModes.CheckVerificationCode) {
                this.setState({
                  verificationCode: e.target.value,
                });
              }
              if (
                mode === LoginPageModes.Login ||
                mode === LoginPageModes.changePassword
              ) {
                this.setState({
                  password: e.target.value,
                });
              }
            }}
          />
          {mode === LoginPageModes.changePassword && (
            <>
              <label style={{ marginTop: "25.3px", color: "#707070" }}>
                {window.sys_app_translate("Confirm Password", "en")}
              </label>
              <input
                type="password"
                className="form-control inter inter-semi-bold"
                placeholder={window.sys_app_translate(
                  "Confirm your new password",
                  "en",
                )}
                value={this.state.confirmPassword}
                onChange={(e) => {
                  this.setState({
                    confirmPassword: e.target.value,
                  });
                }}
              />
            </>
          )}
        </>
      )
    );
  }
  _getForgotPasswordLink() {
    const { mode } = this.state;
    return (
      <div
        className="d-flex justify-content-between"
        style={{ marginTop: "21px" }}
      >
        {/* <select name="" id="">
                          {window.sys_app_translate("select Language", "en")}
                          <option value="">AR</option>
                        </select> */}
        {mode === LoginPageModes.Login && (
          <a
            className="inter inter-semi-bold forgot-password-link"
            onClick={() => {
              this.setState({
                mode: LoginPageModes.SendVerificationCode,
              });
            }}
          >
            {window.sys_app_translate("Forgot Password?", "en")}
          </a>
        )}
      </div>
    );
  }
  _getLoginButton() {
    const { loading } = this.props,
      { mode } = this.state;
    return (
      <Button
        variant="contained"
        className="login-button inter inter-bold"
        type="submit"
        disabled={loading}
        onClick={(e) => {
          this.submit(e);
        }}
      >
        {window.sys_app_translate(
          mode !== LoginPageModes.Login ? "Send" : "Login",
          "en",
        )}
      </Button>
    );
  }
  _getSendPasswordResetButton() {
    const { mode } = this.state;
    return (
      mode === LoginPageModes.CheckVerificationCode && (
        <div className="mt-2 d-flex justify-content-center">
          <span className="inter inter-semi-bold">
            {window.sys_app_translate("Didn't receive the code?", "en")}
          </span>
          <a
            className="inter inter-semi-bold mx-2"
            style={{
              color: AppConfig.themeColors.primary,
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={() => {
              this.sendPasswordResetRequest();
            }}
          >
            {window.sys_app_translate("Resend Now", "en")}
          </a>
        </div>
      )
    );
  }
  render() {
    const {
      loading,
      user,
      showMessage,
      twoFaRequired,
      isPasswordChangeRequired,
    } = this.props;
    return (
      <ErrorBoundary FallbackComponent={this.errorFallback} onReset={() => { }}>
        {loading && <LoginLoading />}
        <div className="container-fluid login-page">
          <div className="row">
            <LoginLeftSidebar />
            <div className="col-12 col-sm-5 px-0" style={{ zIndex: "100" }}>
              <div className="container-fluid ">
                <div className="row left-side-layer-2 px-0">
                  <div className="col-10 offset-1 col-sm-6 offset-sm-0">
                    <div className="text-center">
                      {/* TODO: Check or modify brand logo -i */}
                    </div>
                    {!twoFaRequired && !isPasswordChangeRequired && (
                      <h2 className="inter inter-bold login-form-title">
                        {this._getFormTitle()}
                      </h2>
                    )}
                    <form action="">
                      {!twoFaRequired && !isPasswordChangeRequired && (
                        <>
                          {this._getEmailAddress()}
                          {this._getPasswordField()}
                          {this._getForgotPasswordLink()}
                          {this._getLoginButton()}
                          {this._getSendPasswordResetButton()}
                        </>
                      )}
                      {twoFaRequired && !isPasswordChangeRequired && (
                        <TwoFactorAuthForm
                          verifyTwoFactorCode={(code) => {
                            this.loginUser(code, null);
                          }}
                        />
                      )}
                      {isPasswordChangeRequired && (
                        <PasswordChange
                          showMessage={showMessage}
                          changePassword={(password) => {
                            this.loginUser(null, password);
                          }}
                        />
                      )}
                    </form>
                  </div>
                  <div
                    className="col-1 col-sm-6 right-side"
                    style={{ height: "50%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { loading, twoFaRequired, isPasswordChangeRequired } = appReducer;
  return { user, loading, twoFaRequired, isPasswordChangeRequired };
};

export default connect(mapStateToProps, {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
  set2FaAsRequired,
  setPasswordChangeAsRequired,
})(LoginPage);